export interface ITimeZone {
  name: string;
  countries: string[];
  utcOffset: number;
  utcOffsetStr: string;
  dstOffset: number;
  dstOffsetStr: string;
  aliasOf: any;
}
export const initialTimeZone: ITimeZone = {
  name: 'Etc/UTC',
  countries: [],
  utcOffset: 0,
  utcOffsetStr: '+00:00',
  dstOffset: 0,
  dstOffsetStr: '+00:00',
  aliasOf: null,
};

export type sendTimeZoneServerResponse = ITimeZone;
export type sendTimeZoneMapperResponse = ITimeZone;
